export const zonalGrossMarginHeaderElements = [
  { label: "Cultivos", value: "cultivos" },
  { label: "Zona Productiva", value: "zonaProductiva" },
  { label: "Campaña", value: "campana" },
  { label: "Equilibrio (qq)", value: "equilibrio" },
  { label: "Rinde Estimado (qq)", value: "rindeEstimado" },
];
